<forge-toolbar>
    <h2 slot="before-start" class="forge-typography--heading4">Login</h2>
</forge-toolbar>

@if(useTylerId()){
<ng-container *ngTemplateOutlet="tid">
</ng-container>
}
@else {
<ng-container *ngTemplateOutlet="radius">
</ng-container>
}

<ng-template #busy>
    <forge-circular-progress diameter="30">
    </forge-circular-progress>
</ng-template>

<ng-template #radius>
    <form [formGroup]="loginForm" (ngSubmit)="login()">
        <lgd-text controlName="username" label="Username" class="login-field">
        </lgd-text>

        <lgd-password controlName="password" label="Password" class="login-field" autocomplete="current-password">
        </lgd-password>

        <div fxLayout="row" fxLayoutAlign="center center" class="error-container">
            <div class="forge-typography--subheading1">
                {{error()}}
            </div>
        </div>

        <div fxLayout="column" fxLayoutAlign="space-between stretch">
            <forge-button full-width type="submit" variant="raised" [disabled]="loginForm.invalid">
                <span *ngIf="!loading(); else busy">Sign in</span>
            </forge-button>

            <forge-button full-width type="button" (click)="logout()" class="logout">
                Logout
            </forge-button>
        </div>
    </form>

</ng-template>

<ng-template #tid>
    @if (loading()){
    <forge-circular-progress diameter="30">
    </forge-circular-progress>
    }
    @else {
    <div fxLayout="row" fxLayoutAlign="center center" class="error-container">
        <div class="forge-typography--subheading1">
            {{error()}}
        </div>
    </div>
    }
</ng-template>